import router from "@/router";
import store from "@/store";
import { Loading } from "element-ui";
import moment from "moment-timezone";

const directionByRole = {
	admin: { name: "storiesManage" },
	manager: { name: "storiesManage" },
	editor: { name: "storiesManage" },
	judge: { name: "judgeStoriesList" },
	user: { name: "myDFC" },
	visitor: { name: "editStory" }
};

function redirectByRole(role, options = {}) {
	return { ...directionByRole[role], ...options };
}

function checkPermission(role = undefined, roles = []) {
	return new Promise((resolve, reject) => {
		if (!roles || roles.length == 0 || roles.indexOf(role) >= 0) {
			return resolve();
		}
		reject("權限錯誤！");
	});
}

router.beforeEach(async (to, from, next) => {
	// survey-cake 路徑不需要登入驗證
	if (to.path === '/survey-cake') {
		next();
		return;
	}

	if (localStorage.getItem("token")) {
		// 已登入（已拿到 token ）

		const loading = Loading.service({ lock: true, fullscreen: true });

		if (to.name == "Login") {
			// 不需重新登入（導向首頁）
			next({ path: "/redirect" });
		} else {
			let user = store.state.user.userInfo;
			if (!user.role) {
				try {
					// 若還未取得使用者資料，則取得使用者資料
					await store.dispatch("user/fetchUserInfo");
					user = store.state.user.userInfo;
				} catch (error) {
					// 錯誤（ token 不正確），重新登入
					await store.dispatch("logout");
					next({ name: "Login" });
				}
			}
			if (to.path == "/redirect") {
				// 依照 role 導向正確的首頁
				let options;
				if (user.role == "visitor") options = { params: { id: user.id } };
				next(redirectByRole(user.role, options));
			} else {
				try {
					// 檢查權限，正確則直接進入
					await checkPermission(user.role, to.meta.roles);
					next();
				} catch (error) {
					// 錯誤則重新導向正確首頁
					next({ path: "/redirect" });
				}
			}
		}

		loading.close();
	} else {
		if (to.matched.length > 0 && !to.meta.roles && !to.meta.authorization) {
			// 如果在「白名單」裡則直接進入：
			// 有定義在 router 中，但不需登入（沒有 roles 和 authorization）
			next();
		} else {
			// 否則重新導向登入頁
			next({ name: "Login" });
		}
	}
});
